import { Fragment, useContext, useMemo, useState } from "react";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { Button } from "rizzui";
import cn from "../../../utils/classNames";
import ParksList from "./ParksList";


const ParksListWrapper = () => {

    // STATES

    const [openModalForm, setOpenModalForm] = useState<boolean>(false);


    // HOOKS

    const { userCan } = useContext(PrivilegeContext);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de parques' },
        { name: 'Parques eólicos', href: '/parks' },
    ];

    const defaultFilters = useMemo(() => {
        return {
            status: null,
        };
    }, []);

    // RENDER

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters}>
                <PageHeader title="Gestión de parques" breadcrumb={breadCrumb}>
                    {userCan('create', 'park') && (
                        <Button
                            color="primary"
                            onClick={() => { setOpenModalForm(true) }}
                            className={cn(['mt-4 md:mt-0'])}
                        >
                            Crear parque
                        </Button>
                    )}
                </PageHeader>
                <ParksList openModalForm={openModalForm} setIsOpenModalForm={setOpenModalForm} />
            </FiltersProvider>
        </Fragment>
    )

}


export default ParksListWrapper;